module.exports = __webpack_public_path__ + "menu_0_pc.823c53a2.png";